// ------------------------------------
// Imports
// ------------------------------------
import { translate } from 'utilities/general-utils'
import protocols from 'common-protocols'

// ------------------------------------
// Constants
// ------------------------------------
export const SET_ANSWERS_SALIDA = 'SET_ANSWERS_SALIDA'
export const SET_IS_PROCESSING_VIEW_DATA = 'SET_IS_PROCESSING_VIEW_DATA'
export const SET_MODAL_LOADER_MESSAGE = 'SET_MODAL_LOADER_MESSAGE'
export const SET_PRODUCTS = 'SET_PRODUCTS'
export const SET_PRODUCTS_IN_CART = 'SET_PRODUCTS_IN_CART'
export const SET_TOTAL_QTY = 'SET_TOTAL_QTY'
export const SET_TOTAL_TO_PAY = 'SET_TOTAL_TO_PAY'

// ------------------------------------
// Actions
// ------------------------------------

export function setIsProcessingViewData (data) {
  return {
    type: SET_IS_PROCESSING_VIEW_DATA,
    payload: data
  }
}

export function setModalLoaderMessage (data) {
  return {
    type: SET_MODAL_LOADER_MESSAGE,
    payload: data
  }
}

export function setAnswersSalida (data) {
  return {
    type: SET_ANSWERS_SALIDA,
    payload: data
  }
}

export function setProducts (data) {
  return {
    type: SET_PRODUCTS,
    payload: data
  }
}

export function setProductsInCart (data) {
  return {
    type: SET_PRODUCTS_IN_CART,
    payload: data
  }
}

export function setTotalQTY (data) {
  return {
    type: SET_TOTAL_QTY,
    payload: data
  }
}

export function setTotalToPay (data) {
  return {
    type: SET_TOTAL_TO_PAY,
    payload: data
  }
}

export const actions = {

  setIsProcessingViewData,
  setModalLoaderMessage,
  setAnswersSalida,
  setProducts,
  setProductsInCart,
  setTotalQTY,
  setTotalToPay
}

// ------------------------------------
// Action Handlers
// ------------------------------------
const ACTION_HANDLERS = {

  [SET_IS_PROCESSING_VIEW_DATA]: (state, action) => ({
    ...state,
    isProcessingViewData: action.payload
  }),

  [SET_MODAL_LOADER_MESSAGE]: (state, action) => ({
    ...state,
    modalLoaderMessage: action.payload
  }),

  [SET_ANSWERS_SALIDA]: (state, action) => ({
    ...state,
    fetchAnswers: action.payload
  }),

  [SET_PRODUCTS]: (state, action) => ({
    ...state,
    products: action.payload
  }),

  [SET_PRODUCTS_IN_CART]: (state, action) => ({
    ...state,
    productsInCart: action.payload
  }),

  [SET_TOTAL_QTY]: (state, action) => ({
    ...state,
    totalQTY: action.payload
  }),

  [SET_TOTAL_TO_PAY]: (state, action) => ({
    ...state,
    totalToPay: action.payload
  }),
};

// ------------------------------------
// Reducers
// ------------------------------------
const initialState = {
  // bandera para activar modalbox para mostrar mensajes
  isProcessingViewData : false,
  // mensaje a mostar del modalbox
  modalLoaderMessage   : translate('modalLoader_messageNone'),
  // respuestas del usuario
  fetchAnswers : [
    {
      id:1,
      answerA: false,
      answerB: false,
      answerC: false,
      answerD: false,
      answerE: false,
      answerF: false,
      answerG: false,
      answersSelected : [ {valor: ''}]
    },
    {
      id:2,
      answerA: false,
      answerB: false,
      answerC: false,
      answerD: false,
      answerE: false,
      answerF: false,
      answerG: false,
      answersSelected : [ {valor: ''}]
    },
    {
      id: 3,
      answerA: false,
      answerB: false,
      answerC: false,
      answerD: false,
      answerE: false,
      answerF: false,
      answerG: false,
      answersSelected : [ {valor: ''}]
    },
    {
      id: 4,
      answerA: false,
      answerB: false,
      answerC: false,
      answerD: false,
      answerE: false,
      answerF: false,
      answerG: false,
      answersSelected : [ {valor: ''}]
    },
    {
      id: 5,
      answerA: false,
      answerB: false,
      answerC: false,
      answerD: false,
      answerE: false,
      answerF: false,
      answerG: false,
      answersSelected : [ {valor: ''}]
    },
    {
      id: 6,
      answerA: false,
      answerB: false,
      answerC: false,
      answerD: false,
      answerE: false,
      answerF: false,
      answerG: false,
      answersSelected : [ {valor: ''}]
    },
    {
      id: 7,
      answerA: false,
      answerB: false,
      answerC: false,
      answerD: false,
      answerE: false,
      answerF: false,
      answerG: false,
      answersSelected : [ {valor: ''}]
    },
    {
      id: 8,
      answerA: false,
      answerB: false,
      answerC: false,
      answerD: false,
      answerE: false,
      answerF: false,
      answerG: false,
      answersSelected : [ {valor: ''}]
    },
    {
      id: 9,
      answerA: false,
      answerB: false,
      answerC: false,
      answerD: false,
      answerE: false,
      answerF: false,
      answerG: false,
      answersSelected : [ {valor: ''}]
    },
    {
      id: 10,
      answerA: false,
      answerB: false,
      answerC: false,
      answerD: false,
      answerE: false,
      answerF: false,
      answerG: false,
      answersSelected : [ {valor: ''}]
    },
    {
      id: 11,
      answerA: false,
      department: 'Bebidas',
      answersSelected : [ {valor: ''}]
    },
    {
      id: 12,
      answerA: false,
      department: 'Botanas',
      answersSelected : [ {valor: ''}]
    },
    {
      id: 13,
      answerA: false,
      department: 'Cereales',
      answersSelected : [ {valor: ''}]
    },
    {
      id: 14,
      answerA: false,
      department: 'Lácteos',
      answersSelected : [ {valor: ''}]
    },
    {
      id: 15,
      answerA: false,
      department: 'Listos',
      answersSelected : [ {valor: ''}]
    }
  ],
  // productos elegidos aleatoriamente
  products : {
    beverages : {},
    snacks : {},
    cereals : {},
    dairyProducts : {},
    readyToEat : {}
  },
  // productos agregados al carrito
  productsInCart: [],

  //total de productos
  totalQTY: 0,
  //total a pagar
  totalToPay: 0,

}

export default function summariesReducer (state = initialState, action) {

  const handler = ACTION_HANDLERS[action.type];
  return handler ? handler(state, action) : state;
}



// WEBPACK FOOTER //
// ./src/routes/Home/routes/VirtualMarket/routes/Summaries/modules/module-summaries.js